// @ts-nocheck
import { createContext } from 'react';

export const AuthContext = createContext();
export const AppContext = createContext();
export const UploadContext = createContext();
export const SupportNudgeContext = createContext({ suppressSupportNudge: () => {} });
